import { Component, Input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'boels-product-eco',
  templateUrl: './product-eco.component.html',
  styleUrls: ['./product-eco.component.scss'],
  imports: [TranslocoModule, NgbTooltipModule],
})
export class ProductEcoComponent {
  @Input() tooltipText = '';
  @Input() alt = this.tooltipText;
}
